import { ReactElement } from 'react';
import { UIIcon, UISection, UISectionHeader, UISpinner } from '@/ui';
import { Task } from '@/api';
import { charcoal } from '@/ui/styles';
import { MiniTaskItem } from './mini-task-item';
import { useNavigate } from 'react-router';
import { useTasksTranslation } from '../hooks';

type MiniTasksListProps = {
    tasks: Task[];
    loading: boolean;
};

export function MiniTasksList(props: MiniTasksListProps): ReactElement {
    const { tasks, loading } = props;

    const { t } = useTasksTranslation();
    const navigate = useNavigate();

    return (
        <UISection fill>
            <UISectionHeader title={t('components.mini_tasks_list.title')} />

            {tasks.length === 0 && !loading && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        gap: 8,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <UIIcon name="clipboard" size={48} color={charcoal} />
                    {t('shared.tasks.no_task_data')}
                </div>
            )}
            {tasks.length === 0 && loading && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        gap: 8,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <UISpinner color={charcoal} />
                    {t('shared.labels.loading')}
                </div>
            )}
            {tasks.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        flex: '1 1 0',
                        flexDirection: 'column',
                        paddingTop: 8,
                        overflowY: 'auto',
                        paddingLeft: 8,
                        paddingRight: 8
                    }}
                >
                    {tasks.map((task) => (
                        <MiniTaskItem
                            key={task.id}
                            task={task}
                            onClick={() => {
                                void navigate(
                                    `/company/${task.companyId}/tasks/${task.id}`
                                );
                            }}
                        />
                    ))}
                </div>
            )}
        </UISection>
    );
}
